<template>
  <section class="header-prematch-withreferee">
    <div class="header-prematch-withreferee__cont-date">
      <div class="flag-live-movil">
        <div class="label-time-live" v-if="live == 1 && matchlapse != -1">
          <template v-if="matchlapse != -1">
            <span class="label-time-live__bold">
              <template v-if="matchlapse == 1">1er</template>
              <template v-if="matchlapse == 2">Medio tiempo</template>
              <template v-if="matchlapse == 3">2do</template>
              <template v-if="matchlapse == 4">Finalizado</template>
            </span>
            <template v-if="matchlapse == 1 || matchlapse == 3">&nbsp;tiempo</template>
          </template>
        </div>
        <div class="live" v-if="live == 1">
          <div></div>
          <div>LIVE</div>
        </div>
      </div>
      <div class="header-prematch-withreferee__cont-date__day">{{ htmlEntities(headerDate.date) }}</div>
      <div class="header-prematch-withreferee__cont-date__sep"></div>
      <div class="header-prematch-withreferee__cont-date__stadium">{{ htmlEntities(headerDate.stadium) }}</div>
    </div>
    <div class="header-prematch-withreferee__title">
      ANÁLISIS <span class="header-prematch-withreferee__title__bold">TIEMPO EFECTIVO</span> EN LO QUE VA DEL TORNEO
    </div>

    <div class="header-prematch-withreferee__cont-result">
      <template v-if="type == 0">
        <div class="header-prematch-withreferee__cont-result__game-cont">
          <div class="header-prematch-withreferee__cont-result__game-cont__item">
            <div class="header-prematch-withreferee__cont-result__game-cont__item__imgteam">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
            </div>
            <div class="header-prematch-withreferee__cont-result__game-cont__item__vs">VS</div>
            <div class="header-prematch-withreferee__cont-result__game-cont__item__imgteam">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
            </div>
          </div>
        </div>
        <div class="header-prematch-withreferee__cont-result__referee-cont">
          <div class="header-prematch-withreferee__cont-result__referee-cont__item">
            <div class="header-prematch-withreferee__cont-result__referee-cont__item__imgreferee">
              <img :src="'https://golstatsimages.blob.core.windows.net/photo-referee/' + referee.id + '.jpg'" />
            </div>
            <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee">
              <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee__title">
                Arbitro:
              </div>
              <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee__name">
                {{ changeNameReferee(referee.name) }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="type == 1">
        <div class="header-prematch-withreferee__cont-result__game-cont">
          <div class="header-prematch-withreferee__cont-result__game-cont__item">
            <div class="header-prematch-withreferee__cont-result__game-cont__item__imgteam">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.home_team + '.png'" />
            </div>
            <div class="header-prematch-withreferee__cont-result__game-cont__item__vs">VS</div>
            <div class="header-prematch-withreferee__cont-result__game-cont__item__imgteam">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teams.visiting_team + '.png'" />
            </div>
          </div>
        </div>
      </template>
      <template v-if="type == 2">
        <div class="header-prematch-withreferee__cont-result__referee-cont">
          <div class="header-prematch-withreferee__cont-result__referee-cont__item">
            <div class="header-prematch-withreferee__cont-result__referee-cont__item__imgreferee">
              <img :src="'https://golstatsimages.blob.core.windows.net/photo-referee/' + referee.id + '.jpg'" />
            </div>
            <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee">
              <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee__title">
                Arbitro:
              </div>
              <div class="header-prematch-withreferee__cont-result__referee-cont__item__inforeferee__name">
                {{ changeNameReferee(referee.name) }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderPreMatchWithReferee',
  components: {},
  props: {
    type: {
      type: Number,
      default: 0,
    },
    headerDate: {
      type: Object,
      required: true,
    },
    teams: {
      type: Object,
      required: true,
    },
    referee: {
      type: Object,
      required: true,
    },
    headerInfoPostMatch: {
      type: Object,
      required: true,
    },
    live: {
      type: Number,
      default: 0,
      required: true,
    },
    matchlapse: {
      type: Number,
      default: -1,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    changeNameReferee(name) {
      if (name === 'Sin designar') {
        return name;
      }
      let nameRefereePrint = '';
      if (name != null) {
        let nameTrim = name.trim();
        let auxReferee = nameTrim.split(', ');
        let apellidoAuxReferee = auxReferee[0].split(' ');
        let nameAuxReferee = auxReferee[1].split(' ');
        let auxNameInitials = '';
        for (let index = 0; index < nameAuxReferee.length; index++) {
          auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
        }
        nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
      }
      return nameRefereePrint;
    },
    htmlEntities(str) {
      return String(str)
        .replaceAll('&ntilde;', 'ñ')
        .replaceAll('&Ntilde;', 'Ñ')
        .replaceAll('&amp;', '&')
        .replaceAll('&Ntilde;', 'Ñ')
        .replaceAll('&ntilde;', 'ñ')
        .replaceAll('&Ntilde;', 'Ñ')
        .replaceAll('&Agrave;', 'À')
        .replaceAll('&Aacute;', 'Á')
        .replaceAll('&Acirc;', 'Â')
        .replaceAll('&ocuate;', 'ó')
        .replaceAll('&Atilde;', 'Ã')
        .replaceAll('&Auml;', 'Ä')
        .replaceAll('&Aring;', 'Å')
        .replaceAll('&AElig;', 'Æ')
        .replaceAll('&Ccedil;', 'Ç')
        .replaceAll('&Egrave;', 'È')
        .replaceAll('&Eacute;', 'É')
        .replaceAll('&Ecirc;', 'Ê')
        .replaceAll('&Euml;', 'Ë')
        .replaceAll('&Igrave;', 'Ì')
        .replaceAll('&Iacute;', 'Í')
        .replaceAll('&Icirc;', 'Î')
        .replaceAll('&Iuml;', 'Ï')
        .replaceAll('&ETH;', 'Ð')
        .replaceAll('&Ntilde;', 'Ñ')
        .replaceAll('&Ograve;', 'Ò')
        .replaceAll('&Oacute;', 'Ó')
        .replaceAll('&Ocirc;', 'Ô')
        .replaceAll('&Otilde;', 'Õ')
        .replaceAll('&Ouml;', 'Ö')
        .replaceAll('&Oslash;', 'Ø')
        .replaceAll('&Ugrave;', 'Ù')
        .replaceAll('&Uacute;', 'Ú')
        .replaceAll('&Ucirc;', 'Û')
        .replaceAll('&Uuml;', 'Ü')
        .replaceAll('&Yacute;', 'Ý')
        .replaceAll('&THORN;', 'Þ')
        .replaceAll('&szlig;', 'ß')
        .replaceAll('&agrave;', 'à')
        .replaceAll('&aacute;', 'á')
        .replaceAll('&acirc;', 'â')
        .replaceAll('&atilde;', 'ã')
        .replaceAll('&auml;', 'ä')
        .replaceAll('&aring;', 'å')
        .replaceAll('&aelig;', 'æ')
        .replaceAll('&ccedil;', 'ç')
        .replaceAll('&egrave;', 'è')
        .replaceAll('&eacute;', 'é')
        .replaceAll('&ecirc;', 'ê')
        .replaceAll('&euml;', 'ë')
        .replaceAll('&igrave;', 'ì')
        .replaceAll('&iacute;', 'í')
        .replaceAll('&icirc;', 'î')
        .replaceAll('&iuml;', 'ï')
        .replaceAll('&eth;', 'ð')
        .replaceAll('&ntilde;', 'ñ')
        .replaceAll('&ograve;', 'ò')
        .replaceAll('&oacute;', 'ó')
        .replaceAll('&ocirc;', 'ô')
        .replaceAll('&otilde;', 'õ')
        .replaceAll('&ouml;', 'ö')
        .replaceAll('&oslash;', 'ø')
        .replaceAll('&ugrave;', 'ù')
        .replaceAll('&uacute;', 'ú')
        .replaceAll('&ucirc;', 'û')
        .replaceAll('&uuml;', 'ü')
        .replaceAll('&yacute;', 'ý')
        .replaceAll('&thorn;', 'þ')
        .replaceAll('&yuml;', 'ÿ');
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.label-time-live {
  width: 142px;
  height: 16px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.22px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  background-color: #fea40f;
  font-family: 'Avenir-Demi-Medium';
  &__bold {
    font-family: 'Avenir-Bold';
  }
}
.flag-live-movil {
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.time-live {
  width: 71px;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Bold';
  margin-left: 10px;
  margin-right: 10px;
}
.live {
  padding: 0.6em 1.2em 0.3em 1.2em;
  display: flex;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: -0.16px;
  text-align: center;
  color: #132839;
  border-radius: 5px;
  background-color: #cbfb48;
  font-family: 'Avenir-Demi';
  margin-left: 10px;
  margin-right: 10px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.33;
  letter-spacing: -0.24px;
  text-align: center;
  color: #132839;
  @media screen and (max-width: 830px) {
    width: 65px;
  }

  & > div:first-child {
    margin-top: -4px;
    height: 9px;
    width: 9px;
    border-radius: 50%;
    background-color: #5277fc;
    margin-right: 4px;
    @media screen and (max-width: 830px) {
      margin-top: -4px;
      height: 9px;
      width: 9px;
    }
  }
}
.header-prematch-withreferee {
  width: 100%;
  height: auto;
  display: inline-block;
  &__cont-date {
    width: 100%;
    height: 20px;
    display: inline-flex;
    justify-content: right;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 930px) {
      justify-content: center;
    }
    @media screen and (max-width: 830px) {
      display: none;
    }
    &__day {
      font-family: 'Avenir-Demi-Medium';
      width: auto;
      height: 20px;
      line-height: 20px;
      text-transform: capitalize;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
      @media screen and (max-width: 930px) {
        width: 50%;
        width: auto;
        font-size: 14px;
      }
      @media screen and (max-width: 830px) {
        font-size: 15px;
      }
    }
    &__sep {
      width: 0.5%;
      height: 20px;
      border-left: 1px solid #132839;
      margin-left: 1%;
      margin-right: 1%;
    }
    &__stadium {
      width: auto;
      height: 20px;
      font-family: 'Avenir-Bold';
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 20px;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
      margin-right: 1%;
      @media screen and (max-width: 930px) {
        width: auto;
        text-align: center;
        font-size: 14px;
      }
      @media screen and (max-width: 830px) {
        width: auto;
        margin-right: 0%;
        font-size: 15px;
        text-align: center;
      }
    }
  }
  &__title {
    width: 100%;
    height: 20px;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 20px;
    letter-spacing: normal;
    text-align: center;
    margin-top: 12px;
    font-family: 'Avenir-Regular';
    color: #132839;
    &__bold {
      font-family: 'Avenir-Bold';
    }
    @media screen and (max-width: 830px) {
      display: none;
    }
    @media screen and (max-width: 1030px) {
      font-size: 19px;
    }
    @media screen and (max-width: 380px) {
      font-size: 17px;
    }
    @media screen and (max-width: 380px) {
      font-size: 15px;
    }
  }
  &__cont-result {
    width: 100%;
    height: 90px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 830px) {
      height: auto;
    }
    &__game-cont {
      width: 48.7%;
      height: 88px;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 830px) {
        width: 100%;
        height: auto;
      }
      &__item {
        width: 240px;
        height: 56px;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        &__imgteam {
          width: 56px;
          height: 56px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          img {
            width: 40px;
          }
        }
        &__vs {
          width: 128px;
          height: 56px;
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          font-size: 23px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.39;
          letter-spacing: normal;
          text-align: center;
          color: #132839;
          font-family: 'Avenir-Bold';
        }
      }
    }
    &__referee-cont {
      width: 48.7%;
      height: 88px;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 830px) {
        width: 100%;
        height: 58px;
      }
      &__item {
        width: auto;
        height: 47px;
        display: inline-flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        &__imgreferee {
          width: 34px;
          height: 47px;
          img {
            width: 34px;
          }
        }
        &__inforeferee {
          width: auto;
          height: 47px;
          margin-left: 10px;
          &__title {
            width: 100%;
            height: 23.5px;
            font-size: 15px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 23.5px;
            letter-spacing: normal;
            text-align: left;
            color: #132839;
            font-family: 'Avenir-Demi-Medium';
          }
          &__name {
            width: 100%;
            height: 23.5px;
            font-family: 'Avenir-bold';
            font-size: 17px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 17px;
            letter-spacing: normal;
            text-align: left;
            color: #132839;
          }
        }
      }
    }
  }
}
</style>
